import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessageService } from './message.service';
import { SettingsService } from './settings.service';
import { ConfigLoaderService } from '../config/configloader.service';
import { Status } from '../models/status';
import { Statuscategory } from '../models/statuscategory';
import { KanbanColumn } from '../models/kanban/kanbanColumn';
import { BoardState } from '../models/boardstate';
import { ProjectService } from './project.service';


@Injectable({
  providedIn: 'root'
  })
export class KanbanProjectService extends ProjectService {

  constructor(
    http: HttpClient,
    messageService: MessageService,
    settingsService: SettingsService,
    configService: ConfigLoaderService
  ) {
    super(http, messageService, settingsService, configService);
  }

  protected mapAPIDataToBoardstateObject(data: any): BoardState {
    const columns: KanbanColumn[] = [];
    data['columns'].forEach(columnEntry => {
      const statuses: Status[] = [];

      columnEntry['statuses'].forEach(statusEntry => {
        const statusCategoryData = statusEntry['statusCategory'];
        const statusCategory = new Statuscategory(
          statusCategoryData['colorName'],
          statusCategoryData['id'],
          statusCategoryData['key']
        );

        const status = new Status(
          statusEntry['description'],
          statusEntry['iconUrl'],
          statusEntry['id'],
          statusEntry['name'],
          statusCategory
        );
        statuses.push(status);
      });
      const column = new KanbanColumn(columnEntry['name'], statuses, columnEntry['max']);
      columns.push(column);
    });

    return new BoardState(columns, data['type']);
  }
}
